import React from 'react'
import { Link } from 'react-router-dom'


const Card = (props) => {
    const { items } = props;
    return (
        <div className='card'>
            <h3>-{items.score}-</h3>
            <span className='bar'></span>
            <p className='btc'>{items.coin}</p>
            <p>- {items.day} -</p>
            <p>- View -</p>
            <p>- Feature -</p>
            <p>- Private Quarters -</p>
            <Link to='/contact' className='btn'>Book</Link>
        </div>
    )
}

export default Card